import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../../axiosInstance";
import "./ReLoginPage.css";

const Modal = ({ message, onClose }) => {
  if (!message) return null;

  return (
    <div className="modal">
      <div className="modal-content">
        <p>{message}</p>
        <button className="close-button" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  );
};

let OTPlessSignin = null;
async function OTPlessSdk( navigate) {
  return new Promise(async (resolve) => {
    if (document.getElementById("otpless-sdk") && OTPlessSignin) return resolve();

    const script = document.createElement("script");
    script.src = "https://otpless.com/v4/headless.js";
    script.id = "otpless-sdk";
    script.setAttribute("data-appid", "UZVLBTV3S7MLCXMPRN0C");

    script.onload = function () {
      const OTPless = Reflect.get(window, "OTPless");
      OTPlessSignin = new OTPless((eventCallback) =>
        callback(eventCallback, navigate)
      );
      resolve();
    };
    document.head.appendChild(script);
  });
}

async function hitOTPlessSdk(params, navigate) {
  await OTPlessSdk( navigate);
  const { requestType, request } = params;
  return await OTPlessSignin[requestType](request);
}

const callback = async (eventCallback, navigate) => {
  const ONETAP = async () => {
    const { response } = eventCallback;
    //localStorage.setItem("sessiontoken", response.idToken);
    //localStorage.setItem("userRole", "reporter");

    //await saveSession();
    //navigate("/reporter/dashboard");
  };

  const OTP_AUTO_READ = () => {
    const { response: { otp } } = eventCallback;
    const otpInput = document.getElementById("otp-input");
    otpInput.value = otp;
  };

  const FAILED = () => {
    const { response } = eventCallback;
    console.error("OTP verification failed response:", response);
  };

  const EVENTS_MAP = {
    ONETAP,
    OTP_AUTO_READ,
    FAILED,
  };

  if ("responseType" in eventCallback) EVENTS_MAP[eventCallback.responseType]();
};

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [mobileNumber, setMobileNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const initiateOtp = async () => {
    if (!mobileNumber) {
      setError("Please enter your mobile number.");
      return;
    }

    try {
      const response = await axios.post("/api/forgotpassword/reporter/verify", {
        mobileNumber,
      });

      if (response.data?.status === "success") {
        setLoading(true);
        localStorage.setItem("reporterId", response.data.reporterId);
        const request = {
          channel: "PHONE",
          phone: mobileNumber,
          countryCode: "+91",
          deliveryChannel: "SMS",
          otpLength: 6,
          expiry: "60",
        };

        try {
          const response = await hitOTPlessSdk(
            { requestType: "initiate", request },
            navigate
          );

          if (response.success) {
            setOtpSent(true);
            setStep(2);
            setError("");
          } else {
            setError("Failed to initiate OTP. Please try again.");
          }
        } catch (error) {
          setError("An error occurred while sending OTP.");
        } finally {
          setLoading(false);
        }
      } else {
        setError(response.data?.error || "Invalid mobile number or password.");
      }
    } catch (error) {
      setError(
        error.response?.data?.error || "An unexpected error occurred. Please try again."
      );
    }
  };
  
  const verifyOtp = async () => {
    if (!otp) {
      setError("Please enter the OTP.");
      return;
    }

    setLoading(true);
    const request = {
      channel: "PHONE",
      phone: mobileNumber,
      otp,
      countryCode: "+91",
    };

    try {
      const response = await hitOTPlessSdk(
        { requestType: "verify", request },
        //saveSession,
        navigate
      );

      if (response.success) {
        setModalMessage("OTP verified successfully!");
        //navigate("/reporter/dashboard");
        setStep(3);

      } else {
        setError("Invalid OTP. Please try again.");
      }
    } catch (error) {
      setError("An error occurred while verifying OTP.");
    } finally {
      setLoading(false);
    }
  };
  const resetPassword = async () => {
    if (!newPassword || !confirmPassword) {
      setError("Please enter and confirm your new password.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post("/api/reporter/reset", { mobileNumber, newPassword });
      if (response.data.success) {
        setError("");
        navigate("/reporter/login");
      } else {
        setError("Failed to reset password.");
      }
    } catch (error) {
      setError("An error occurred while resetting password.");
    }
    setLoading(false);
  };

  return (
    <div className="reporterlogin">
    <div className="login-container">
      <h2>Forgot Password</h2>
      {error && <p className="error-message">{error}</p>}
      
      {step === 1 && (
        
        <div className="input-group">
          <label>Mobile Number</label>
          <div className="input-icon-group1">
          <i className="fas fa-phone icon"></i>
          <input type="text" value={mobileNumber} onChange={(e) => setMobileNumber(e.target.value)} placeholder="Enter mobile number" />
          </div>
          <button onClick={initiateOtp} className="login-button" disabled={loading}>{loading ? "Sending OTP..." : "Send OTP"}</button>
          </div>
      
      )}

      {step === 2 && (
        <div className="input-group">
          <label>Enter OTP</label>
          <div className="input-icon-group1">
          <input type="text" value={otp} onChange={(e) => setOtp(e.target.value)} placeholder="Enter OTP" />
          </div>
          <button onClick={verifyOtp} className="login-button" disabled={loading}>{loading ? "Verifying..." : "Verify OTP"}</button>
        </div>
      )}

      {step === 3 && (
        <div className="input-group">
          <label>New Password</label>
          <div className="input-icon-group1">
          <i className="fas fa-key icon"></i>
          <input type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="Enter new password" />
          </div>
          <label>Confirm Password</label>
          <div className="input-icon-group1">
          <i className="fas fa-key icon"></i>
          <input type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Confirm new password" />
          </div>
          
          <button onClick={resetPassword} className="login-button" disabled={loading}>{loading ? "Resetting..." : "Reset Password"}</button>
        </div>
      )}
    </div>
    </div>
  );
};

export default ForgotPassword;
